import Terrain from 'lib/Terrain';

const THREE = window.THREE;

class Wave {
  static initClass() {
    this.prototype.canvasGL    = null;
    this.prototype.container   = null;
    this.prototype.scene       = null;
    this.prototype.camera      = null;
    this.prototype.renderer    = null;
    this.prototype.geometry    = null;
    this.prototype.material    = null;
    this.prototype.mesh        = null;
    this.prototype.gui         = null;
    this.prototype.terrain     = null;
    this.prototype.composer    = null;
    this.prototype.render_pass = null;
    this.prototype.fxaa_pass   = null;
    this.prototype.posteffect  = false;
    this.prototype.meteo       = null;
    this.prototype.skybox      = null;
  }

  init = () => {
    this.scene = new THREE.Scene();

    this.camera = new THREE.PerspectiveCamera(60, window.innerWidth / window.innerHeight, 0.1, 100000);
    this.camera.position.z = 2;
    this.camera.position.y = 2;
    this.camera.position.x = 2;
    this.renderer = new THREE.WebGLRenderer({
      width: window.innerWidth,
      height: window.innerHeight,
      scale: 1,
      antialias: false,
      alpha: false
    });

    let width = window.innerWidth;
    //if (width > 1440) width = 1440;
    this.renderer.setSize(width, window.innerHeight);

    this.container = document.createElement('div');
    this.container.id = 'canvasGL';
    this.container.style.zIndex = 2;
    this.container.style.position = 'relative';
    this.container.style.textAlign = 'center';
    this.container.appendChild(this.renderer.domElement);

    this.camera.lookAt(new THREE.Vector3());
    document.getElementById('experience').appendChild(this.container);
    this.terrain = new Terrain(this.scene);
    this.scene.add(this.terrain.plane_mesh);
    return this.update();
  }

  update = () => {
    requestAnimationFrame(this.update);
    this.terrain.update();
    return this.renderScene();
  }

  renderScene = () => {
    return this.renderer.render(this.scene, this.camera);
  }

  resize = () => {
    let width = window.innerWidth;
    //if (width > 1440) width = 1440;
    let height = window.innerHeight;
    this.camera.aspect = width / height;
    this.camera.updateProjectionMatrix();
    return this.renderer.setSize(width, height);
  }
}
Wave.initClass();
export default Wave;



// WEBPACK FOOTER //
// ./src/lib/Wave.js